import { render, staticRenderFns } from "./recap-stock.html?vue&type=template&id=1dac5653&scoped=true&external"
import script from "./recap-stock.js?vue&type=script&lang=js&external"
export * from "./recap-stock.js?vue&type=script&lang=js&external"
import style0 from "./recap-stock.scss?vue&type=style&index=0&id=1dac5653&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dac5653",
  null
  
)

export default component.exports